const TimelineItemSingle = (props) => {
  return (
    <div>
      <svg
        width="200%"
        height="100%"
        style={{ position: "absolute", top: 0, left: 0, zIndex: 500 }}
      >
        <g
          transform={`translate(${props.width / 2},${props.timelineInterval})`}
          key={props.index}
        >
          <circle
            cx={0}
            cy={0}
            r={5}
            fill={props.item.event_type === "SD" ? "#093746" : "#0d657d"}
          />
          <line
            x1={0}
            x2={
              props.item.event_type === "SD"
                ? props.width * 0.03
                : -props.width * 0.03
            }
            stroke={props.item.event_type === "SD" ? "#093746" : "#0d657d"}
          />
        </g>
      </svg>
      <div
        style={{
          position: "absolute",
          width: props.width * 0.45,
          left:
            props.item.event_type === "SD"
              ? props.width * 0.525
              : props.width * 0.025,
          top: props.timelineInterval - 15,
        }}
      >
        <p
          className="mxy-0 f-smed"
          style={{
            color: props.item.event_type === "SD" ? "#093746" : "#0d657d",
          }}
        >
          {props.item.date} | <strong>{props.item.country} </strong>
        </p>
        {/* <p className="mxy-0 f-smed" style={{ marginBottom:2, color:props.item.event_type === "SD" ? "#093746" : "#0d657d" }}>
          <strong>{props.item.country} </strong>
        </p> */}
        <p
          className="f-small mxy-0"
          style={{ paddingLeft: 5, paddingRight: 5 }}
        >
          {props.item.description}
        </p>
      </div>
    </div>
  );
};

export default TimelineItemSingle;
